//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "ShipperOrder",
    components: {
        MyBtnReturn
    },
    data() {
        return {
            // todo:逻辑应该是：上层中某个选项变化了，下面所有select与受影响的input都要变为null
            load_date: '',
            consignee_id: null, // 囧，selector组件要设置默认值为null时，placeholder才有效果！
            consigneeOps: [
                // {
                //   key: 'lsh',
                //   value: '李四'
                // },
                // {
                //   key: 'zhs',
                //   value: '张三'
                // }
            ],
            goods_name: '',
            dockOfLoading: null,
            dockOfLoadingOps: [
                // '广东',
                // '上海',
            ],
            finalDestination: null,
            finalDestinationOps: [],
            jhr: null,
            jhrOps: [],
            company_lxr: null,
            company_lxrOps: [],
            shipper_tel: '',
            shipper_mp: '',
            remark3: '', // 装货说明
            consignee_place: null,
            consignee_placeOps: [],
            consignee_linkman: null,
            consignee_linkmanOps: [],
            consignee_tel: '',
            consignee_mp: '',
            remark9: '', // 卸货说明
            carriage: null,
            carriageOps: [
                {
                    key: 'DR-DR',
                    value: '门/门'
                },
                {
                    key: 'DR-CY',
                    value: '门/堆场'
                },
                {
                    key: 'CY-DR',
                    value: '堆场/门'
                },
                {
                    key: 'CY-CY',
                    value: '堆场/堆场'
                },
            ],
            contQty: '', // todo:柜量还要进行处理？
            contType: null,
            contTypeOps: [
                // {
                //   key: '20',
                //   value: '20GP'
                // },
                // {
                //   key: '40',
                //   value: '20GP'
                // },
            ], // todo:后台传递来
            insurance_status: null,
            insurance_statusOps: [
                {
                    key: '1',
                    value: '是'
                },
                {
                    key: '0',
                    value: '否'
                },
            ],
            fees_remark2: '',
            group: '', // 这个由shipperOrder接口获得，不知道是否要传回去
            shipper: '', // 这个由shipperOrder接口获得，托运人，在获取目的地时也要传递
            employeeId: '',
            isDisabledList: {
                consigSelector: false,
                dockOfLoadingSelector: false,
                finalDestinationSelector: false,
                jhrSelector: false,
                companyLxrSelector: false,
                consigneePlaceSelector: false,
                consigneeLinkmanSelector: false,
            }, // 这个对象存放控制各个selector组件的readonly属性的值
            canSubmit: true, // true代表能继续发送请求，控制submit方法的
        }
    },
    created() {
        document.title = '客户下单';
        this.getInitialSelectData()
    },
    methods: {
        getInitialSelectData() {
            // 可获取到shipper(托运人)、employeeId(对应业务员？)、conts(柜型柜量)、consignees(货主？)、startAreas(起运地)
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: apiUrl.shipperOrder,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                let dataObj = resultData.data;
                this.consigneeOps = dataObj.consignees;
                this.group = dataObj.group;
                this.shipper = dataObj.shipper;
                // this.shipperOps = dataObj.shippers
                this.employeeId = dataObj.employeeId;
                this.consigneeOps = dataObj.consignees;
                this.contTypeOps = dataObj.conts;
                this.dockOfLoadingOps = dataObj.startAreas // 起运地
            }, (error) => {
                this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(() => {
                        this.getInitialSelectData()
                    }, 2000);
                    console.error(error);
                }
            })
        },
        // 由于on-change会立即调用一次，因此如果value为null，要中止函数
        // 如果用户在第一次请求还未完成时，就又触发了change事件，然后第二次请求完成速度比第一次还快，怎么办？？
        // 处理上述bug：一旦改变了选项，那就禁用selector组件，等请求完毕后再启用
        getArea(value, ref) {
            // 获取目的地：通过托运人与货主去查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取目的地：通过托运人与货主去查询
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
            };
            this.requestApi({
                url: apiUrl.getArea,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.finalDestinationOps = dataObj.area;
                this.finalDestination = null // 要重置为null，避免默认选中值没改
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    // todo:除了getInitialSelectData可以自动重新请求外，其他change事件触发的接口不可自动重新获取，不然万一用户修改选项，请求数据会混乱了！
                    // 处理上述bug：因此如果请求失败了，那就重置select的默认值为null
                    this.consignee_id = null;
                    console.error(error);
                }
            })
        },
        getLoadJhr(value, ref) {
            // 获取装货地址：根据起运地查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '', // 也可以直接使用参数value
            };
            this.requestApi({
                url: apiUrl.getPlace,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.jhrOps = dataObj.places;
                this.jhr = null
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.dockOfLoading = null;
                    console.error(error);
                }
            })
        },
        getConsigPlace(value, ref) {
            // 获取卸货地址：根据目的地去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || '',
            };
            this.requestApi({
                url: apiUrl.getPlace,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.consignee_placeOps = dataObj.places;
                this.consignee_place = null
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.finalDestination = null;
                    console.error(error);
                }
            })
        },
        getLoadLink(value, ref) {
            // 获取装货联系人：根据起运地+装货地址去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '',
                place: this.jhr || '',
            };
            this.requestApi({
                url: apiUrl.getLinkman,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.company_lxrOps = dataObj.linkmans;
                this.company_lxr = null
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.jhr = null;
                    console.error(error);
                }
            })
        },
        getLoadTelMp(value, ref) {
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取装货人手机电话：根据起运地+装货地址+装货联系人获取
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '',
                place: this.jhr || '',
                linkman: this.company_lxr || '',
            };
            this.requestApi({
                url: apiUrl.getOtherloadInfo,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                // todo:手机与电话好像是放在loadInfo数组里面
                this.shipper_tel = dataObj.loadInfo[1];
                this.shipper_mp = dataObj.loadInfo[0]
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.company_lxr = null;
                    console.error(error);
                }
            })
        },
        getXHLink(value, ref) {
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货联系人：根据目的地+卸货地址获取
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || '',
                place: this.consignee_place || '',
            };
            this.requestApi({
                url: apiUrl.getLinkman,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.consignee_linkmanOps = dataObj.linkmans;
                this.consignee_linkman = null
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.consignee_place = null;
                    console.error(error);
                }
            })
        },
        getXhTelMp(value, ref) {
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货人手机电话：根据目的地+卸货地址+卸货联系人获取
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || '',
                place: this.consignee_place || '',
                linkman: this.consignee_linkman || '',
            };
            this.requestApi({
                url: apiUrl.getOtherloadInfo,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                // 手机与电话好像是放在loadInfo数组里面，loadInfo:["13678978756", null]
                this.consignee_tel = dataObj.loadInfo[1];
                this.consignee_mp = dataObj.loadInfo[0]
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.consignee_linkman = null;
                    console.error(error);
                }
            })
        },
        submit(e) {
            // 对表单各项进行检测
            if (!this.load_date) {
                this.showToastWarn('请选择装货时间');
                return
            }
            if (!this.consignee_id) {
                this.showToastWarn('请输入货主');
                return
            }
            if (!this.goods_name) {
                this.showToastWarn('请输入货名');
                return
            }
            if (!this.dockOfLoading) {
                this.showToastWarn('请输入起运地');
                return
            }
            if (!this.finalDestination) {
                this.showToastWarn('请输入目的地');
                return
            }
            if (!this.jhr) {
                this.showToastWarn('请输入装货地址');
                return
            }
            if (!this.company_lxr) {
                this.showToastWarn('请输入装货联系人');
                return
            }
            if (!(this.shipper_mp || this.shipper_tel)) {
                this.showToastWarn('装货联系人手机,电话至少输入一个');
                return
            }
            if (!this.consignee_place) {
                this.showToastWarn('请输入卸货地址');
                return
            }
            if (!this.consignee_linkman) {
                this.showToastWarn('请输入卸货联系人');
                return
            }
            if (!(this.consignee_tel || this.consignee_mp)) {
                this.showToastWarn('卸货联系人手机,电话至少输入一个');
                return
            }
            if (!this.contQty) {
                this.showToastWarn('请输入柜量');
                return
            } else if (isNaN(Number(this.contQty))) {
                // 柜量必须是数字，而且是整数
                this.showToastWarn('柜量必须为数字');
                return
            }
            if (!this.fees_remark2) {
                this.showToastWarn('请输入费用说明');
                return
            }
            // 防止连续调用接口：也可直接给loading
            if (!this.canSubmit) return;
            this.canSubmit = false;
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 提交下单信息
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                employeeId: this.employeeId || '',
                load_date: this.load_date,
                consignee_id: this.consignee_id,
                goods_name: this.goods_name,
                dockOfLoading: this.dockOfLoading,
                finalDestination: this.finalDestination,
                jhr: this.jhr,
                company_lxr: this.company_lxr,
                shipper_tel: this.shipper_tel || '',
                shipper_mp: this.shipper_mp || '',
                remark3: this.remark3,
                consignee_place: this.consignee_place,
                consignee_linkman: this.consignee_linkman,
                consignee_tel: this.consignee_tel || '',
                consignee_mp: this.consignee_mp || '',
                remark9: this.remark9,
                carriage_item: this.carriage,
                contQty: parseInt(this.contQty),
                contType: this.contType,
                insurance_status: this.insurance_status || 0,
                fees_remark2: this.fees_remark2,
                group: this.group,
            };
            this.requestApi({
                url: apiUrl.shipperAddOrder,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                // 最后判断下单是否成功，给toast，状态码为200就是成功
                let dataObj = resultData.data;
                this.showToast(dataObj.info, 1500, 'success', {
                    onHide: () => {
                        this.$router.push('/home')
                    }
                })
            }, (error) => {
                this.canSubmit = true;
                this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            })
        },
        showToastWarn(text, time = 1500) {
            // 专门给submit函数里的验证使用
            this.showToast(text, time, 'warn')
        },
        isDisabled(ref) {
            // 在触发select的change事件后，要先禁用select，等到请求完毕后，再重启select功能
            // 两种实现方式：1、第一种是通过ref获取到对应dom元素，然后禁用：
            // this.$refs[ref].$el.querySelector('select').disabled = !this.$refs[ref].$el.querySelector('select').disabled

            // 2、第二种是控制对应数据去设置selector组件的readonly属性
            this.isDisabledList[ref] = !this.isDisabledList[ref]
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/kehu/shipperOrder/ShipperOrder.vue